<script setup lang="ts">
const { isSmsIntegrationEnabled } = useFeatureFlagsJson();
const { userPhone, userPhoneDdi } = useUserData();
const { recoveryPasswordFlow } = storeToRefs(useAuthStore());

const isPhoneSmsVerification = computed(() => {
  return (
    (isSmsIntegrationEnabled.value &&
      !!userPhone.value &&
      !!userPhoneDdi.value) ||
    recoveryPasswordFlow.value?.token
  );
});
</script>

<template>
  <AuthVerificationPhoneSms v-if="isPhoneSmsVerification" />
  <AuthVerificationPhone v-else />
</template>
